export enum Likes {
  EarDials = 'EarDials',
  EmotionalSupporting = 'EmotionalSupporting',
  FootSqueezing = 'FootSqueezing',
  GumRubs = 'GumRubs',
  Kisses = 'Kisses',
  RoughPets = 'RoughPets',
  Taps = 'Taps',
}
